import { StatementStatus } from './types';

export const CLIENT_ROUTE = '/statement';
export const API_ROUTE = '/api/statements';
export const CLIENT_TITLE = 'Хуулга';

export const STATEMENT: Record<StatementStatus, string> = {
    [StatementStatus.FAILED]: 'Алдаа гарсан',
    [StatementStatus.RESOLVED]: 'Шийдвэрлэсэн'
}